import { useTranslation } from 'react-i18next';

import { localStorageAvailable, localStorageGetItem } from 'src/utils/storage-available';

import { allLangs, defaultLang } from './config-lang';

import { axiosInstance } from '../utils/axios';

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();

  const storageAvailable = localStorageAvailable();

  const langStorage = storageAvailable ? localStorageGetItem('i18nextLng') : '';
  const currentLang = allLangs.find((_lang) => _lang.value === langStorage) || defaultLang;

  const handleChangeLanguage = (newlang) => {
    axiosInstance.defaults.headers['Accept-Language'] = newlang;
    i18n.changeLanguage(newlang);
    console.log('Change lng...', newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate: (text, options) => translate(text, options),
    currentLang,
    allLangs,
  };
}
